/**
 * Module to take care of the API calls and Model of reporting and schedules features.
 */
define('dataSource/reporting/reporting',['knockout', 'jquery', 'lodash', 'moment', 'atn/atn', 'dataSource/session',
    'dataSource/timeData'
],
        function (ko, $, _, moment, atn, session, timeData) {
            'use strict';
            /**
             * list on all reports
             * @type {ko.observableArray}
             */
            // var reportsList = ko.observableArray([]),
            var singleReportObj = {
                    reportColumnDataFormat:"TEXT",
                    reportColumnId:1,
                    reportColumnOrder:1,
                    reportColumnUserProvidedName:"Customer Name"
            };
            /**
             * [singleReport the single report observable container]
             * @type {ko.observable}
             */
            var singleReport = ko.observable(),
            rawDataReportColumns = ko.observableArray([]),
            hiddenColumns = [],
                    /**
                     * [lastSuccess for handling the report route after network error]
                     * @type {ko.observable}
                     */
                    lastSuccess = ko.observable(true),
                    /**
                     * observable for showing loading panel
                     * @type {ko.observable}
                     */
                    isLoading = ko.observable(false),
                    /**
                     * observable object for handling errors in loading of schedule
                     * @type {ko.observable}
                     */
                    errorObservable = ko.observable({}),
                    /**
                     * Error in loading all reports
                     */
                    errorLoadingReports = ko.observable('');


            /**
             * [nullReportObject the report null object]
             * @type {Object}
             */
            var nullReportObject = {
                chartConfigs: [],
                rawDataColumnsConfig: [singleReportObj],
                durationType: 'custom',
                rawDataTimeConfig: [{type: "duration", value: "30", unit: "day"}],
                reportScheduleId: null,
                reportType: "CHART",
                timezone: session.session().userTimezone.id,
                timeZoneOffsetStr: session.session().userTimezone.id,
                name: '',
                scheduleType: 'RECURRING',
                oneTimeScheduleType: 'send_now',
                oneTimeScheduleTime: null,
                recurringScheduleStart: null,
                recurringScheduleEnd: null,
                metricDurationStartDate: null,
                metricDurationEndDate:  null,
                recurringScheduleInterval: '7',
                recurringScheduleUnit: 'DAY',
                scheduleEmailRecipients: '' + session.session().email,
                scheduleActive: true,
                nextDeliveryTime: null
            };

            /**
             * object for enumerating frequency unit field
             * @type {object}
             */
            var frequencyUnitData = [{
                    'text': 'Day(s)',
                    'id': 'DAY'
                }, {
                    'text': 'Week(s)',
                    'id': 'WEEK'
                }, {
                    'text': 'Month(s)',
                    'id': 'MONTH'
                }];
            
            var durationUnitData = [{
                    'text': 'Day(s)',
                    'id': 'day'
                }, {
                    'text': 'Week(s)',
                    'id': 'week'
                }, {
                    'text': 'Month(s)',
                    'id': 'month'
                }];
            var formatOptionsData = [{
                    'text': 'Text',
                    'id': 'TEXT'
                }, {
                    'text': 'Number',
                    'id': 'NUMBER'
                }, {
                    'text': 'Yes / No',
                    'id': 'BOOLEAN'
                }, {
                    'text': 'KB',
                    'id': 'KB'
                }, {
                    'text': 'MB',
                    'id': 'MB'
                }, {
                    'text': 'GB',
                    'id': 'GB'
                }, {
                    'text': 'TB',
                    'id': 'TB'
                }, {
                    'text': 'PB',
                    'id': 'PB'
                }];
            

            var reportsList = ko.observableArray([]);

            //the below code clears the observables passed on logout.
            atn.dataCache.addRegistry(reportsList);

            /**
             * The polling object used to maintain the state and functioning 
             * of the generate PDF now function. 
             */

            var reportPollCodes = {
                DONE: 'SUCCESSFUL',
                FAILED: 'FAILED',
                POLLING: 'IN_PROGRESS'
            };
            
            
            var validRawDataFormatsHash = {};

            /**
             * requireJS module return
             */
            return {
                getReportsList: getReportsList,
                getSingleReport: getSingleReport,
                addReport: addReport,
                updateReport: updateReport,
                deleteReportSchedule: deleteReportSchedule,
                emailReport: emailReport,
                reportsList: reportsList,
                singleReport: singleReport,
                isLoading: isLoading,
                errorObservable: errorObservable,
                errorLoadingReports: errorLoadingReports,
                frequencyUnitData: frequencyUnitData,
                durationUnitData: durationUnitData,
                formatOptionsData: formatOptionsData,
                lastSuccess: lastSuccess,
                singleReportObj: singleReportObj,
                nullReportObject: nullReportObject,
                createReportsList: createReportsList,
                getRawDataReportColumns: getRawDataReportColumns,
                validRawDataFormatsHash: validRawDataFormatsHash,
                hiddenColumns: hiddenColumns
            };

            /**
             * function to get list of ThirdPartyEndpoints only when reload is reqd. i.e. the list is not already fetched
             * @param  {boolean} reload        is reload required?
             * @return {jquery.promise}        promise for getting list of ThirdPartyEndpoints
             **/
            function getReportsList(reload) {
                var promise;
                if (reload || !reportsList().length) {
                    promise = createReportsList();
                } else {
                    promise = atn.utils.dummySuccessDeferred();
                }
                return promise;
            }

            /**
             * function to get list of ThirdPartyEndpoints from API
             * @param  {boolean} reload        is reload required
             * @return {jquery.promise}        promise for getting list of ThirdPartyEndpoints
             */
            function createReportsList() {
                var promise,
                        deferred = $.Deferred();
                isLoading(true);
                //  making service call
                promise = atn.rest.get(
                        atn.config.api.reports + "?pagesize=5000",
                        'pageResults',
                        reportsList,
                        errorLoadingReports,
                        modifyReportsModelList
                        );

                promise.done(function () {
                    deferred.resolve();
                });

                promise.fail(function (xhr) {
                    deferred.reject(xhr);
                });

                promise.always(function () {
                    isLoading(false);
                });

                return deferred.promise();
            }

            /**
             * This function is used to get single scheduled report
             * @param  {integer} scheduleId reportid of the schedule
             * @return {promise}
             */
            function getSingleReport(reportId) {
                var promise,
                        deferred = $.Deferred();

                isLoading(true);
                /** making service call **/
                promise = atn.rest.get(
                        atn.utils.createURL(atn.config.api.reports + '/' + reportId),
                        'pageResults',
                        singleReport,
                        errorObservable,
                        modifySingleReportModel,
                        null
                        );

                promise.done(function () {
                    deferred.resolve(singleReport);
                });

                promise.fail(function () {
                    deferred.reject();
                });

                promise.always(function () {
                    isLoading(false);
                });
                return deferred.promise();
            }
            
            function getRawDataReportColumns() {
                var promise,
                        deferred = $.Deferred();

                isLoading(true);
                /** making service call **/
                promise = atn.rest.get(
                        atn.utils.createURL(atn.config.api.rawDataReportColumns),
                        'pageResults',
                        rawDataReportColumns,
                        errorObservable
                        );

                promise.done(function () {
                    var tmp = [];
                    hiddenColumns.splice(0,hiddenColumns.length);
                    _.each(rawDataReportColumns(), function(column, index){
                             validRawDataFormatsHash[column.id()] = column.dataFormats();
                             if(!column.showColumn()){
                                 hiddenColumns.push(column);
                            }else{
                                tmp.push(column);
                            }
                    });
                    rawDataReportColumns(tmp);
                    deferred.resolve(rawDataReportColumns);
                });

                promise.fail(function () {
                    deferred.reject();
                });

                promise.always(function () {
                    isLoading(false);
                });
                return deferred.promise();
            }

            /**
             * API call to add a new reporting schedule by using the data entered in the new schedule form
             * @param {observable} scheduleObservable      [schedule trackable observable carrying data]
             * @param {observable} scheduleErrorObservable [error tracking observable]
             * @return {promise} promise object for adding schedule
             */
            function addReport(reportObservable, reportErrorObservable) {
                var newReportObservable = ko.observable();
                var newReportData = modifyReportRequest(ko.mapping.toJS(reportObservable));
                var deferred = $.Deferred();
                isLoading(true);
                var promise = atn.rest.post(
                        atn.config.api.reports,
                        'reportConfig',
                        newReportData,
                        newReportObservable,
                        reportErrorObservable,
                        modifySingleReportModel
                        );
                promise.done(function () {
                    reportsList.push(newReportObservable());
                    reportObservable.reset();
                    _.defer(isLoading, false);
                    deferred.resolve(reportObservable);
                });
                promise.fail(function () {
                    _.defer(isLoading, false);
                    deferred.reject();
                });
                return deferred.promise();
            }

            /**
             * API call to update a report by using the data entered in the Update report form
             * @param  {observable} reportTrackable [report trackable observable carrying data]
             * @param  {observable} errorObservable   [error tracking observable]
             * @return {promise object}                   [promise object for updating report]
             */
            function updateReport(reportTrackable, errorObservable) {
                var deferred = $.Deferred();
                isLoading(true);
                var promise = atn.rest.put(
                        atn.config.api.reports + '/' + reportTrackable().reportScheduleId(),
                        'reportConfig',
                        modifyReportRequest,
                        reportTrackable,
                        errorObservable,
                        modifySingleReportModel
                        );
                promise.done(function () {
                    _.defer(isLoading, false);
                    getReportsList(true);
                    deferred.resolve();
                });
                promise.fail(function () {
                    _.defer(isLoading, false);
                    deferred.reject();
                });
                return deferred.promise();
            }

            /**
             * API call to delete a schedule from backend.
             * @param  {number} id [ID of the schedule to be deleted]
             * @return {promise object}        [promise object for deleting schedule]
             */
            function deleteReportSchedule(reportId) {
                var deferred = $.Deferred(),
                        promise = atn.rest.destroy(
                                atn.config.api.reports + '/' + reportId
                                );

                promise.done(function () {
                    /**
                     * delete the corresponding report from the grid data
                     */
                    reportsList.remove(_.find(reportsList(), function (report) {
                        return report.reportScheduleId() === reportId;
                    }));
                    deferred.resolve.apply(reportsList, arguments);
                });

                promise.fail(function (xhr) {
                    deferred.reject(xhr);
                });

                return deferred.promise();
            }

            /**
             * API call to send report now
             * @param  {number} id [ID of the schedule to be deleted]
             * @return {promise object}        [promise object for deleting schedule]
             */
            function emailReport(reportId) {
                var errorObservable = ko.observable({}),
                    newReportObservable = ko.observable(),
                    deferred = $.Deferred(),
                    promise = atn.rest.post(
                            atn.config.api.reports + '/' + reportId + '/emailReport',
                            'reportConfig',
                            JSON.stringify({}),
                            newReportObservable,
                            errorObservable
                    );
        
                promise.done(function (response) {
                    deferred.resolve(response.requestId);                    
                });

                promise.fail(function () {
                    _.defer(isLoading, false);
                    deferred.reject();
                });
                return deferred.promise();
            }

            /**
             * [modifyReportsModelList function to convert the reportsLIst recieved from API for UI consumption]
             * @param  {Object} reports [the reportsList got from the API]
             * @return {object}         [the UI consumable reportsList]
             */
            function modifyReportsModelList(reports) {
                var retObj = [];
                retObj = _.map(reports, modifySingleReportModel);
                return retObj;
            }

            /**
             * [modifySingleReportModel function to convert the single report recieved from API for UI consumption]
             * @param  {Object} report [the report got from the API]
             * @return {Object}        [the UI consumable report]
             */
            function modifySingleReportModel(report) {
                var reportModel = {},
                        timezoneObj,
                        timezoneOffset = 0;

                if (report.schedule.timezone) {
                    reportModel.timezone = report.schedule.timezone;
                    timezoneObj = _.find(timeData.timezoneList(), function (timeZone) {
                        return timeZone.value() === report.schedule.timezone;
                    });

                    timezoneOffset = timezoneObj.offset();
                } else {
                    reportModel.timezone = session.session().userTimezone.id;
                }

                reportModel.timeZoneOffsetStr = timezoneObj.text();
                var offsetStr = timezoneObj.offsetStr();
                reportModel.reportScheduleId = report.reportScheduleId;

                reportModel.name = report.reportInfo.name;
                reportModel.reportType = report.reportInfo.reportType;

                reportModel.scheduleActive = report.schedule.active;

                reportModel.scheduleEmailRecipients = report.schedule.emailRecipients.join(',');

                reportModel.scheduleType = report.schedule.scheduleType;
                reportModel.oneTimeScheduleType = 'schedule';

                if (report.schedule.oneTimeSchedule) {
                    reportModel.oneTimeScheduleTime = report.schedule.oneTimeSchedule.scheduleTime ?
                            atn.utils.translateUtcFromRemoteTzToLocalTz(report.schedule.oneTimeSchedule.scheduleTime, timezoneOffset) :
                            '';
                } else {
                    reportModel.oneTimeScheduleTime = null;
                }

                reportModel.recurringScheduleStart = report.schedule.recurringSchedule.startTime ?
                        atn.utils.translateUtcFromRemoteTzToLocalTz(report.schedule.recurringSchedule.startTime, timezoneOffset) :
                        '';

                reportModel.recurringScheduleEnd = report.schedule.recurringSchedule.endTime ?
                        atn.utils.translateUtcFromRemoteTzToLocalTz(report.schedule.recurringSchedule.endTime, timezoneOffset) :
                        '';

                reportModel.recurringScheduleInterval = report.schedule.recurringSchedule.recurringInfo.interval;

                reportModel.recurringScheduleUnit = report.schedule.recurringSchedule.recurringInfo.unit;

                reportModel.nextDeliveryTime = report.nextDeliveryTime ?
                        atn.utils.translateUtcFromRemoteTzToLocalTz(report.nextDeliveryTime, timezoneOffset) :
                        '';

                reportModel.chartConfigs = report.reportInfo.chartConfigs;
                if(report.reportInfo.rawDataConfig){
                    reportModel.rawDataColumnsConfig = _.sortBy(report.reportInfo.rawDataConfig.rawDataColumnsConfig,['reportColumnOrder']);
                    if (report.reportInfo.rawDataConfig.rawDataTimeConfig && report.reportInfo.rawDataConfig.rawDataTimeConfig.length == 2) {
                        for (var j = 0; j < report.reportInfo.rawDataConfig.rawDataTimeConfig.length; j++){
                            var time = report.reportInfo.rawDataConfig.rawDataTimeConfig[j].value * 1000;
                            if(report.reportInfo.rawDataConfig.rawDataTimeConfig[j].type == 'start_time') {
                                reportModel.metricDurationStartDate = atn.utils.translateUtcFromRemoteTzToLocalTz(time, timezoneOffset);
                            }
                            if(report.reportInfo.rawDataConfig.rawDataTimeConfig[j].type == 'end_time') {
                                reportModel.metricDurationEndDate = atn.utils.translateUtcFromRemoteTzToLocalTz(time, timezoneOffset);
                            }
                        }
                        reportModel.rawDataTimeConfig = _.clone(nullReportObject.rawDataTimeConfig);
                        reportModel.durationType = 'custom';
                    }
                    else if (report.reportInfo.rawDataConfig.rawDataTimeConfig && report.reportInfo.rawDataConfig.rawDataTimeConfig.length == 1) {
                        reportModel.durationType = 'last';              
                        reportModel.rawDataTimeConfig = report.reportInfo.rawDataConfig.rawDataTimeConfig;
                        
                        //Set the start and end date
                        var currentDate = new Date();
                        reportModel.metricDurationStartDate = atn.utils.translateUtcFromRemoteTzToLocalTz(new Date().setTime(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000), timezoneOffset);
                        reportModel.metricDurationEndDate = atn.utils.translateUtcFromRemoteTzToLocalTz(currentDate, timezoneOffset);
                    }
                    else if (report.reportInfo.rawDataConfig.rawDataTimeConfig && report.reportInfo.rawDataConfig.rawDataTimeConfig.length == 0) {
                        reportModel.durationType = 'custom';
                        reportModel.rawDataTimeConfig = _.clone(nullReportObject.rawDataTimeConfig);                        
                        //Set the start and end date
                        var currentDate = new Date();
                        reportModel.metricDurationStartDate = atn.utils.translateUtcFromRemoteTzToLocalTz(new Date().setTime(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000), timezoneOffset);
                        reportModel.metricDurationEndDate = atn.utils.translateUtcFromRemoteTzToLocalTz(currentDate, timezoneOffset);
                    }

                }else{
                    reportModel.rawDataColumnsConfig = _.clone(nullReportObject.rawDataColumnsConfig);
                    reportModel.rawDataTimeConfig = _.clone(nullReportObject.rawDataTimeConfig);
                }
                return reportModel;
            }

            /**
             * convert the Data got from the UI to an appropriate request format readable and understood by the server(API)*
             * @param  {object} requestObj [the UI request to be modified to convert to API readable format]
             * @return {object}        [UI request in API readable format]
             */
            function modifyReportRequest(report) {
                return modifyRequest(report);
            }

            /**
             * [modifyRequest common modification task for schedule and reports request modifications]
             * @param  {object} request [the report/schedule object]
             * @return {undefined}
             */
            function modifyRequest(request) {
                var requestRetVal = {};
                var timezoneOffset = _.find(timeData.timezoneList(), function (timeZone) {
                    return timeZone.value() === request.timezone;
                });

                timezoneOffset = timezoneOffset ? timezoneOffset.offset() : 0;

                requestRetVal.reportInfo = {};
                requestRetVal.schedule = {};
                requestRetVal.reportInfo.name = request.name;
                requestRetVal.reportInfo.reportType = request.reportType;
                requestRetVal.schedule.oneTimeSchedule = {
                    scheduleTime: atn.utils.translateLocalToEpochWrtRemoteTz(request.oneTimeScheduleTime, timezoneOffset)
                };
                if (request.reportType === "CHART") {
                    requestRetVal.reportInfo.chartConfigs = request.chartConfigs;
                } else if (request.reportType === "RAW_DATA") {
                    _.each(request.rawDataColumnsConfig, function(column, index){
                            column.reportColumnOrder = index+1;
                    });
                    
                    var durationDataTimeConfig = request.rawDataTimeConfig;
                    if (request.durationType === "custom") {
                        //Convert dates into UTC
                        var durationDataTimeRange = [], startDateUTC, endDateUTC;                        
                        var startTimeUtc = moment(request.metricDurationStartDate).format('ddd MMM DD YYYY') + ' 00:00:00 UTC';
                        var endTimeUtc = moment(request.metricDurationEndDate).format('ddd MMM DD YYYY') + ' 00:00:00 UTC';
                        
                        //Convert time into ecpoch
                        var startTimeEpoch = Math.round(new Date(startTimeUtc).getTime()/1000);
                        var endTimeEpoch = Math.round(new Date(endTimeUtc).getTime()/1000);
                        
                        //Add the dates
                        durationDataTimeRange.push({type: "start_time", value: startTimeEpoch, unit: "epoch"});
                        durationDataTimeRange.push({type: "end_time", value: endTimeEpoch, unit: "epoch"});
                        durationDataTimeConfig = durationDataTimeRange;
                    }
                    requestRetVal.reportInfo.rawDataConfig = {
                        rawDataColumnsConfig: request.rawDataColumnsConfig,
                        rawDataTimeConfig: durationDataTimeConfig
                    };
                    
                    if (request.scheduleType === "ONE_TIME" && request.oneTimeScheduleType === "send_now") {
                        requestRetVal.schedule.oneTimeSchedule = {
                            scheduleTime: -1
                        };
                    }
                }
                requestRetVal.schedule.emailRecipients = _.map(request.scheduleEmailRecipients.split(','), function (value) {
                    //trim spaces at the start/end.
                    return value.replace(/^\s+|\s+$/gm, '');
                });
                requestRetVal.schedule.scheduleType = request.scheduleType;
                requestRetVal.schedule.timezone = request.timezone;

                var recurringScheduleIntervalVal = request.recurringScheduleInterval;
                if(recurringScheduleIntervalVal === null) {
                    recurringScheduleIntervalVal = 7;
                }
                requestRetVal.schedule.recurringSchedule = {
                    startTime: atn.utils.translateLocalToEpochWrtRemoteTz(request.recurringScheduleStart, timezoneOffset),
                    endTime: atn.utils.translateLocalToEpochWrtRemoteTz(request.recurringScheduleEnd, timezoneOffset),
                    recurringInfo: {
                        interval: recurringScheduleIntervalVal,
                        unit: request.recurringScheduleUnit
                    }
                };

                requestRetVal.schedule.active = request.scheduleActive;

                return requestRetVal;
            }
        });

